
























import Vue from 'vue';

export default Vue.extend({
  props: {
    isActive: Boolean,
    topText: String,
    bottomText: String,
    stepNumber: [Number, String],
    icon: String,
  },
});
